import Div from "../division";
import UIWidgetsHeader, {
  UIWidgetsLogo,
  UIWidgetsBreadcrumb,
  UIWidgetsHeaderRightWrapper,
  UIWidgetsAlarm,
  UIWidgetsUser
} from "./Header";
import { Row, Column } from "../../../ui/grids/Grids";

export default function Header({ primary, title, backButton, showCurrentScreen, isAsset }) {
  const goBack = () => window.history.back();
  return (
    <div data-testid="header-component">
      <UIWidgetsHeader primary={primary} isAsset={isAsset}>
        <Row alt="true">
          {backButton && (
            <Column xs="2" sm="2" md="1" lg="1" alt="true">
              <Div>
                <img
                  src={backButton}
                  alt="back-nav-button"
                  data-testid="back-nav-button"
                  onClick={showCurrentScreen ? () => showCurrentScreen(false) : goBack}
                  data-test="go-back"
                />
              </Div>
            </Column>
          )}
          <Column xs="2" sm="2" md="2" lg="2">
            <UIWidgetsBreadcrumb>{title}</UIWidgetsBreadcrumb>
          </Column>
        </Row>
      </UIWidgetsHeader>
    </div>
  );
}
